import { makeNodeIdToAnswerPathMap, NodeIdToAnswerPathMap } from '@zinnia/form-engine-sdk';

import { contract } from './answerPaths/contract';
import { insuredPeople } from './answerPaths/insuredPeople';

export const nodeIdToAnswerPathMap: NodeIdToAnswerPathMap = makeNodeIdToAnswerPathMap([contract, insuredPeople]);
